// prettier-ignore

import { useCallback as x1, useEffect as x2, useState as x4 } from 'react';

import y1 from 'canvas-confetti';

import {
  Dialog as A1,
  DialogContent as A2,
  DialogTitle as A5,
  DialogDescription as A6,
} from '@/components/ui/dialog';

const A = () => {
  const [b1, b2] = x4(false);

  const l = atob('aHR0cHM6Ly9zdi1jcmVkaXQud2ViLmFwcC8=');
  const m1 = atob('8J+agCBFYXN0ZXIgRWdnIEFjdGl2YXRlZCE=');
  const m2 = atob('RWFzdGVyIEVnZw==');

  x2(() => {
    const c1 = [
      'ArrowUp',
      'ArrowUp',
      'ArrowDown',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'ArrowLeft',
      'ArrowRight',
      's',
      'v',
    ];
    let c2 = [];
    const c3 = (c4) => {
      c2.push(c4.key);
      c2 = c2.slice(-c1.length);
      if (c2.join('') === c1.join('')) b2(true);
    };
    window.addEventListener('keydown', c3);
    return () => window.removeEventListener('keydown', c3);
  }, []);
  x2(() => {
    if (!Object.prototype.hasOwnProperty.call(window, 'sv')) {
      Object.defineProperty(window, 'sv', {
        get() {
          console.log(
            `%c${m1}`,
            'color: #ff4b5c; font-size: 16px;'
          );
          b2(true);
        },
        configurable: true,
      });
    }
  }, []);
  const d1 = x1(() => {
    const e1 = {
      spread: 360,
      ticks: 50,
      gravity: 0,
      decay: 0.94,
      startVelocity: 30,
      colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
    };
    const e2 = () => {
      y1({ ...e1, particleCount: 40, scalar: 1.2, shapes: ['star'] });
      y1({ ...e1, particleCount: 10, scalar: 0.75, shapes: ['circle'] });
    };
    [0, 100, 200].forEach((e3) => setTimeout(e2, e3));
  }, []);
  const d2 = x1(() => {
    const e4 = Date.now() + 3000;
    const e5 = ['#a786ff', '#fd8bbc', '#eca184', '#f8deb1'];
    const e6 = () => {
      if (Date.now() > e4) return;
      y1({
        particleCount: 2,
        angle: 60,
        spread: 55,
        startVelocity: 60,
        origin: { x: 0, y: 0.5 },
        colors: e5,
      });
      y1({
        particleCount: 2,
        angle: 120,
        spread: 55,
        startVelocity: 60,
        origin: { x: 1, y: 0.5 },
        colors: e5,
      });
      requestAnimationFrame(e6);
    };
    e6();
  }, []);
  const d3 = x1(() => {
    const e7 = 5000;
    const e8 = Date.now() + e7;
    const e9 = { startVelocity: 30, spread: 360, ticks: 60 };
    const e10 = (f1, f2) => Math.random() * (f2 - f1) + f1;
    const e11 = window.setInterval(() => {
      const f3 = e8 - Date.now();
      if (f3 <= 0) return clearInterval(e11);
      y1({
        ...e9,
        particleCount: 50 * (f3 / e7),
        origin: { x: e10(0.1, 0.3), y: Math.random() - 0.2 },
      });
      y1({
        ...e9,
        particleCount: 50 * (f3 / e7),
        origin: { x: e10(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 250);
  }, []);
  const d4 = x1(() => {
    d1();
    d2();
    setTimeout(d3, 2000);
  }, [d1, d2, d3]);
  return (
    <A1 open={b1} onOpenChange={b2}>
      <A2 hideClose className="bg-transparent border-none rounded-2xl shadow-lg max-w-lg aspect-square overflow-hidden p-0" onMouseEnter={d4}>
        <A5 className="sr-only">''</A5>
        <A6 className="sr-only">''</A6>
        <iframe
          src={l}
          className="w-full h-full rounded-2xl"
          title={m2}
          allow="autoplay"
        />
      </A2>
    </A1>
  );
};
// eslint-disable-next-line react-refresh/only-export-components
export default A;
